import { stayFoundSteps } from "@/mocks/home";

export default function StayFoundSteps() {
  return (
    <section id="guide" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-accent-400 uppercase">
            <i className="ri-anchor-line" />
            Stay Found
          </span>
          <h2 className="mt-3 font-heading font-black text-3xl md:text-4xl text-background-50">
            防走失三步
          </h2>
          <p className="mt-3 text-background-300 leading-relaxed">
            防失联最靠谱的办法，是给自己留好几条退路。三步做完，
            下次就算黑料入口打不开，也能顺手换个入口继续看。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {stayFoundSteps.map((item) => (
            <div
              key={item.step}
              className="relative flex flex-col p-6 rounded-lg bg-background-50/5 border border-background-50/10 hover:bg-background-50/10 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <span className="font-heading font-black text-4xl text-background-50/20">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-6 font-heading font-bold text-xl text-background-50">{item.title}</h3>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4 p-5 md:p-6 rounded-lg bg-primary-500">
          <div className="flex items-start gap-3">
            <i className="ri-bookmark-3-fill text-background-50 text-2xl mt-0.5" />
            <div>
              <p className="font-heading font-bold text-background-50 text-lg">
                现在就把这一页存下来
              </p>
              <p className="mt-1 text-sm text-background-50/85">
                加入书签或发送到自己的收藏夹，比记住任何一个域名都管用。
              </p>
            </div>
          </div>
          <a
            href="#top"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-foreground-950 text-background-50 font-label font-medium hover:bg-foreground-900 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" />
            回到顶部收藏
          </a>
        </div>
      </div>
    </section>
  );
}